export default "__VITE_ASSET__pm6X0lR1__"